import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { CollectedPreviewItem, GameType, MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { formatCardName } from "@ponder-shared/utils/general";
import { environment } from "../../../../environments/environment";
import { formatCurrency } from "@ponder-shared/utils/numberFormatter";
import { getMagicCardRoute2 } from "./magicCardRouter";
import { NavigationService } from "@ponder-core/navigation/navigation.service";

@Component({
    selector: "magic-card-versions",
    imports: [NgClass],
    templateUrl: "./magic-card-versions.component.html"
})
export class MagicCardVersionsComponent {
    @Input({ required: true }) public magicCard!: MagicCard;
    @Input({ required: true }) public currIndex = 0;
    @Input({ required: true }) public reprints?: CollectedPreviewItem[];

    @ViewChild("versionTooltip") private versionTooltipRef!: ElementRef<HTMLElement>;

    public hoverTarget?: CollectedPreviewItem;

    public constructor(private navigation: NavigationService) {
        
    }
    
    public getSetIndex(): string | undefined {
        return this.magicCard?.setIndex;
    }

    public getSetName(): string | undefined {
        return `${this.magicCard?.set.name} (${this.magicCard?.set.code?.toUpperCase()})`;
    }

    public getNeighborReprints(): CollectedPreviewItem[] {
        if (!this.reprints) {
            return [];
        }
        
        if (this.reprints.length <= 10) {
            return this.reprints;
        } else {
            // Limit how many we show to 10. Show up to 5 new versions, and then at minimum 5 older versions
            // This allows the user to click through different versions and navigate large lists without clicking "see all"
            var startIndex = Math.max(0, this.currIndex - 5);
            return this.reprints.slice(startIndex, startIndex + 10);
        }
    }

    public onVersionHover(hoveredCard: CollectedPreviewItem): void {
        this.hoverTarget = hoveredCard;
        this.versionTooltipRef.nativeElement.style.setProperty("background-image", `url("${environment.ponderImageBaseUrl}/card/small/front/${this.hoverTarget.item.id!}.jpg")`);
        this.versionTooltipRef.nativeElement.classList.remove("invisible"); 
    }

    public onVersionStopHover(): void {
        this.hoverTarget = undefined;
        this.versionTooltipRef.nativeElement.classList.add("invisible");
    }

    public getVersionUrl(item: CollectedPreviewItem): string {
        return getMagicCardRoute2(item.item.name!, item.item.data!.magic!.set!.code!, item.item.data!.magic!.setIndex!);
    }

    public onVersionClick(item: CollectedPreviewItem): void {
        this.navigation.goto(this.getVersionUrl(item));
    }
    
    public formatName(name: string): string {
        return formatCardName(name);
    }

    public getTooltipName(name: string): string {
        return (name.length > 20 ? name : "");
    }
    public routeToAllVersions(): void {
        this.navigation.goto("/search", { game: GameType.Magic, oracleId: this.magicCard!.oracleId!, exact: "true"});
    }

    public isThisCard(item: CollectedPreviewItem): boolean {
        var magic = item.item.data?.magic;

        if (!magic) {
            return false;
        }

        return (magic.set.code === this.magicCard.set.code) && (magic.setIndex === this.magicCard.setIndex);
    }

    public isCollected(item: CollectedPreviewItem): boolean {
        return (item.collected?.count ? true : false) || (item.collected?.specialCount ? true : false);
    }

    public getPrice(item: CollectedPreviewItem): string {
        if (item.price.normalUSD > 0) {
            return formatCurrency(item.price.normalUSD);
        } else if (item.price.specialUSD > 0) {
            return formatCurrency(item.price.specialUSD);
        } else {
            return "N/A";
        }
    }
}